import { render, staticRenderFns } from "./openCloud.vue?vue&type=template&id=f3ca23b2&scoped=true&"
import script from "./openCloud.vue?vue&type=script&lang=js&"
export * from "./openCloud.vue?vue&type=script&lang=js&"
import style0 from "./openCloud.vue?vue&type=style&index=0&id=f3ca23b2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ca23b2",
  null
  
)

export default component.exports